export interface GamePlayPlayer {
  readonly userId: string
  readonly username: string
}

export const gamePlayPlayerNull: GamePlayPlayer = {
  userId: '',
  username: '',
}
